import {
  Alert,
  Typography,
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  CircularProgress,
  Container,
} from "@mui/material";
import { useState, useReducer } from "react";
import { Link, useNavigate } from "react-router-dom";
import { forgetPassword, resetPassword } from "../../api/auth.js";
import { makeStyles } from "@mui/styles";
import VastEdgeLogo from "../../images/vastedge-logo-white-small.png";
import { ArrowBack } from "@mui/icons-material";
import useSnackbar from "../../hooks/useSnackbar.js";
const useStyles = makeStyles((theme) => ({
  odrBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",

    "@media (max-width: 520px)": {
      marginBottom: "20px",
      width: "90%",
    },
  },
  odrPaperWidth: {
    maxWidth: "445px",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px !important",
    backgroundColor: "#fff !important",
    color: "rgba(0, 0, 0, 0.87) !important",
    WebkitTransition:
      "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    borderRadius: "4px !important",
  },
  odrLoginPage: {
    background:
      "radial-gradient(50% 50% at 50% 50%, #005480  0%, #0c7eb6 100%)",
    height: "100%",
    position: "absolute",
    left: "0",
    width: "100%",
    maxWidth: "100% !important",
    "@media (max-width: 520px)": {
      position: "relative",
    },
  },
  odrLoginHeader: {
    margin: "14px 0px 0px 14px",
  },
  odrBoxTitle: {
    display: "flex",
    flexDirection: "row",
    webkitBoxAlign: "center",
    alignItems: "center",
    WebkitBoxPack: "justify",
    justifyContent: "space-between",
    marginBottom: "1rem",
  },
}));
const initialState = {
  suspense: false,
  err: "",
  step: 1,
  msg: "",
  done: false,
};
const localReducer = (state, action) => {
  switch (action.type) {
    case "SUSPENSE":
      return { ...state, suspense: true, err: "" };
    case "ERROR":
      return { ...state, err: action.payload, suspense: false };
    case "DONE":
      return { ...state, msg: action.payload, suspense: false, done: true };
    case "STEP-2":
      return {
        ...state,
        suspense: false,
        err: "",
        step: 2,
        msg: action.payload,
      };
    case "STEP-1":
      return initialState;
    default:
      return initialState;
  }
};

const emptyData = { email: "", newPassword: "", otp: "" };

export default function ForgetPassword() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(localReducer, initialState);
  const snackbar = useSnackbar();
  const [data, setData] = useState(emptyData);
  const handleInputChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    dispatch({ type: "SUSPENSE" });
    try {
      const res = await forgetPassword(data.email);
      snackbar.showInfo(res.data.msg);
      dispatch({ type: "STEP-2", payload: "" });
      // dispatch({ type: "STEP-2", payload: res.data.msg });
    } catch (error) {
      const res = error.response?.data;
      dispatch({ type: "ERROR", payload: "" });
      // dispatch({ type: "ERROR", payload: res?.error || error.message });
      snackbar.showError(res.error);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    dispatch({ type: "SUSPENSE" });
    try {
      const res = await resetPassword(data.email, data.otp, data.newPassword);
      snackbar.showInfo(res.data.msg);
      dispatch({ type: "DONE", payload: "" });
      navigate("/login");
      // dispatch({ type: "DONE", payload: res.data.msg });
    } catch (error) {
      const res = error.response?.data;
      dispatch({ type: "ERROR", payload: "" });
      // dispatch({ type: "ERROR", payload: res?.error || error.message });
      snackbar.showError(res.error);
    }
  };

  return (
    <Container maxWidth="xl" className={classes.odrLoginPage}>
      <Box
        style={{
          minHeight: "100vh",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12} className={classes.odrLoginHeader}>
            <Link href="https://www.vastedge.com/">
              <img src={VastEdgeLogo} height="45" />
            </Link>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Box className={classes.odrBox}>
              <Paper elevation={3} className={classes.odrPaperWidth}>
                <Box maxWidth={800} px={2} pb={2} pt={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Box className={classes.odrBoxTitle}>
                        <Typography variant="h5" fontWeight={700}>
                          {state.step === 1
                            ? "Forget Password"
                            : "Reset Password"}
                        </Typography>

                        {Boolean(state.suspense) ? (
                          <Box textAlign="center">
                            <CircularProgress />
                          </Box>
                        ) : (
                          <></>
                        )}
                        {Boolean(state.err) ? (
                          <Alert severity="error">{state.err}</Alert>
                        ) : (
                          <></>
                        )}
                        {Boolean(state.msg) ? (
                          <Alert severity="success">{state.msg}</Alert>
                        ) : (
                          <></>
                        )}
                      </Box>
                    </Grid>
                  </Grid>

                  {state.step === 1 ? (
                    <Box component="form" onSubmit={handleEmailSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                          <TextField
                            value={data.email}
                            type="email"
                            label="Email"
                            onChange={handleInputChange}
                            name="email"
                            required
                            fullWidth
                            size="small"
                          />
                        </Grid>

                        <Grid item xs={12} md={12} lg={12}>
                          <Grid container justifyContent="space-between">
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => {
                                navigate("/login", { replace: true });
                              }}
                              className="green-button"
                            >
                              <ArrowBack /> Login Instead
                            </Button>
                            <Button
                              color="primary"
                              type="submit"
                              variant="contained"
                              className="blue-button"
                            >
                              Submit
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : (
                    <Box component="form" onSubmit={handleResetPassword}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                          <TextField
                            value={data.email}
                            type="email"
                            label="Email"
                            onChange={() => {}}
                            disabled={true}
                            name="email"
                            required
                            fullWidth
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                          <TextField
                            value={data.otp}
                            label="OTP"
                            onChange={handleInputChange}
                            name="otp"
                            required
                            fullWidth
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                          <TextField
                            value={data.newPassword}
                            type="password"
                            label="Password"
                            onChange={handleInputChange}
                            name="newPassword"
                            required
                            fullWidth
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                          <Grid container justifyContent="space-between">
                            {state.done ? (
                              <Link to="/login">
                                <Button
                                  color="primary"
                                  type="submit"
                                  variant="contained"
                                >
                                  Login
                                </Button>
                              </Link>
                            ) : (
                              <>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={() => {
                                    setData(emptyData);
                                    dispatch({ type: "STEP-1" });
                                  }}
                                  className="green-button"
                                >
                                  Change Email
                                </Button>
                                <Button
                                  color="primary"
                                  type="submit"
                                  variant="contained"
                                  className="blue-button"
                                >
                                  Submit
                                </Button>
                              </>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </Box>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
